import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import { rootReducer } from 'forms-ai-lib/internal/reducers';
export const configureStore = preloadedState => configureReduxStore({
  reducer: rootReducer,
  preloadedState
});